import React from 'react'
import styled from 'styled-components'

import { Info } from './DesignSystem/Icons'
import Tooltip from './DesignSystem/Tooltip'
import InformationIcon from './InformationIcon'

const StyledLabelText = styled.p`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: var(--ds-gray-3);
  margin: 0 0 4px;
  .icon {
    margin-left: 4px;
  }
`
const RequiredMark = styled.span`
  color: var(--negative-color);
`

/**
 * @typedef {Object} InputProps
 * @property {string} [id]
 * @property {string} [className]
 * @property {string} [notification]
 * @property {string} [text]
 * @property {string} [tooltipText]
 * @property {boolean} [required]
 * @property {boolean} [disabled]
 * @property {boolean} [readOnly]
 * @property {React.CSSProperties} [style]
 */
const LabelText = ({
  text,
  className,
  style,
  disabled,
  readOnly,
  id,
  notification,
  tooltipText,
  required = false,
}) => {
  let labelColor = 'var(--ds-gray-3)'

  if (disabled) labelColor = 'var(--ds-gray-5)'
  if (readOnly) labelColor = 'var(--ds-gray-3)'

  return (
    <StyledLabelText
      id={`${id}_label`}
      style={{ ...style, color: labelColor }}
      className={className}
    >
      <span className="typography-body-2">{text}</span>
      {required && text && <RequiredMark>*</RequiredMark>}
      {notification && (
        <Tooltip
          placement="right"
          overlayStyle={{
            maxWidth: '250px',
            whiteSpace: 'normal',
          }}
          text={notification}
        >
          <Info
            fill="var(--ds-gray-2)"
            style={{ marginLeft: '4px' }}
            hoverFill="var(--primary)"
            width="16px"
            height="16px"
          />
        </Tooltip>
      )}
      {tooltipText && <InformationIcon tooltipText={tooltipText} id={id} />}
    </StyledLabelText>
  )
}

export default LabelText
